/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const catalogueItemDataSchema = z.object({
	id: z.string(),
	type: z.string(),
	name: z.string(),
})

export type CatalogueItemDataSchema = z.infer<typeof catalogueItemDataSchema>
